enum PAYMENT_PLANS {
  BASIC = "BASIC",
  PRO = "PRO",
}

export { PAYMENT_PLANS };
